// https://github.com/tc39/proposal-using-statement
require('../modules/esnext.symbol.async-dispose');
require('../modules/esnext.symbol.dispose');



// WEBPACK FOOTER //
// /Users/kinfirm/Sites/mvgroup/wp-content/themes/mvgroup/node_modules/core-js/proposals/using-statement.js